import wretch from "wretch";
import FormDataAddon from "wretch/addons/formData";
import configData from "../Config";
import { decryptData } from "../utils/utils";
import Config from "../Config";

const postApiHeader = {
  "Content-Type": "application/json",
  accept: "application/json, text/plain",
  "Access-Control-Allow-Origin": "*",
};
const postWithFilesApiHeader = {
  // "Content-Type": "multipart/form-data",
  accept: "*/*",
};

const getAuthHeader = () => {
  const token =
    `Bearer ${
      JSON?.parse(localStorage?.getItem("recoil-persist"))?.userDetail
        ?.authToken
    }` || "";
  return { Authorization: token };
};

export const apis = {
  getApi: async (url) => {
    return (
      wretch()
        .headers({ ...getAuthHeader() })
        .get(url)
        // .options({ mode: "cors", redirect: "follow" })
        .res((data) => data)
        .catch((err) => {
          // if (err?.response?.status === 400) {
          //   errorDataEntryOnHotJar();
          // }
          if (typeof err === "object" && err?.message)
            throw new Error(err?.message);
          else return err;
        })
    );
  },
  getApiWithCustomHeader: async (url, headerData) => {
    return (
      wretch()
        // .headers(headerData)
        .headers({ ...getAuthHeader() })
        .get(url)
        .res((data) => data)
        .catch((err) => {
          // if (err?.response?.status === 400) {
          //   errorDataEntryOnHotJar();
          // }
          if (typeof err === "object" && err?.message)
            throw new Error(err?.message);
          else return err;
        })
    );
  },

  getApiWithCustomHeaderAndResponseType: async (
    url,
    headerData,
    respTypeData
  ) => {
    return (
      wretch()
        // .headers(headerData)
        .headers({ ...getAuthHeader() })
        .get(url)
        .response(respTypeData)
        .res((data) => data)
        .catch((err) => {
          // if (err?.response?.status === 400) {
          //   errorDataEntryOnHotJar();
          // }
          if (typeof err === "object" && err?.message)
            throw new Error(err?.message);
          else return err;
        })
    );
  },
  postApi: async (url, dataObj) => {
    return wretch(url)
      .options({
        mode: "cors",
        redirect: "follow",
        headers: { ...getAuthHeader(), ...postApiHeader },
      })
      .post(dataObj)
      .res((data) => data)
      .catch((err) => {
        // if (err?.response?.status === 400) {
        //   errorDataEntryOnHotJar();
        // }
        if (typeof err === "object" && err?.message)
          throw new Error(err?.message);
        else return err;
      });
  },
  postWithFilesApi: async (url, dataObj) => {
    return wretch(url)
      .addon(FormDataAddon)
      .formData(dataObj)
      .options({
        headers: { ...getAuthHeader(), ...postWithFilesApiHeader },
      })
      .post()
      .res((data) => data)
      .catch((err) => {
        // if (err?.response?.status === 400) {
        //   errorDataEntryOnHotJar();
        // }
        if (typeof err === "object" && err?.message)
          throw new Error(err?.message);
        else return err;
      });
  },
  postApiWithCustomHeader: async (url, dataObj, headerData) => {
    return wretch(url)
      .options({
        mode: "cors",
        redirect: "follow",
        // headers: headerData,
        headers: { ...getAuthHeader() },
      })
      .post(dataObj || {})
      .res((data) => data)
      .catch((err) => {
        // if (err?.response?.status === 400) {
        //   errorDataEntryOnHotJar();
        // }
        if (typeof err === "object" && err?.message)
          throw new Error(err?.message);
        else return err;
      });
  },
};
